import features from './adminFeatures.preval';

export function isFeatureEnabled(flag) {
  return features[flag];
}
